import { render } from "./notFound.vue?vue&type=template&id=2d55c45a&scoped=true"
const script = {}

import "./notFound.vue?vue&type=style&index=0&id=2d55c45a&scoped=true&lang=css"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d55c45a"]])

export default __exports__